import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgEmblemMatchGreat = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>MatchGreat</title>
    <path
      d="m12.141 10.68 2.65-6.355c.451-1.083 1.987-1.082 2.437.002l2.639 6.36 6.862.555c1.17.094 1.644 1.555.752 2.319l-5.233 4.474 1.593 6.699c.271 1.142-.972 2.044-1.973 1.431l-5.873-3.593-5.878 3.584c-1.003.611-2.245-.293-1.971-1.434l1.602-6.696-5.225-4.483c-.891-.765-.415-2.225.755-2.318l6.863-.545Z"
      fill="#5BC86A"
      stroke="#2F3639"
      strokeWidth={2}
    />
    <path
      opacity={0.8}
      d="m19.404 11.652 7.244.587a.32.32 0 0 1 .182.562l-5.465 4.673a.377.377 0 0 0-.07.08l-.077.119-6.035-.619-2.378-5.503.084-.105a.374.374 0 0 0 .053-.09l2.77-6.646a.32.32 0 0 1 .591 0l2.785 6.712c.054.13.176.219.316.23Z"
      fill="#C1EBC7"
    />
  </svg>
);
export default SvgEmblemMatchGreat;
